var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bp-deadline",
      class: _vm.showUrgency ? _vm.urgencyClass : "",
    },
    [
      _vm.days !== null
        ? _c("span", [
            _vm._v(
              _vm._s(_vm.days) + " " + _vm._s(_vm.days === 1 ? "Tag" : "Tage")
            ),
          ])
        : _c("span", [_vm._v("-")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }